import { useEffect,useState } from 'react'

/**
 * Returns `value` once it has been stable for `delayMs`. Pair with useQuery to
 * debounce search inputs: key the query on the debounced value and keep the
 * raw value in state for the input field.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return debounced
}
